import React from "react";
import {IStepAnswer} from "../../../interfaces/IStepAnswer";
import {CardActionArea} from "@material-ui/core";

function AnswerReveal(p: IStepAnswer) {
    return (
        <div className={'answer-reveal'}>
            <div className={'header'}>
                <div className={'header-content'}>
                    <div className={'topic'}>TOPIC</div>
                    <div className={'title'}>
                        {p.header}
                    </div>
                </div>
            </div>

            <div className={'answer-container'}>
                <div className={'answer-content'}>
                    <div className={'label-answer'}>ANSWER: </div>
                    <h1>{p.answer}</h1>
                    <div className={'answer-text'}>
                        <div dangerouslySetInnerHTML={{__html: p.transcript}}/>
                    </div>

                    <div className={'answer-action-area'}>
                        <CardActionArea className={'transcript-previous-button'} onClick={p.moveBack}>
                            Previous
                        </CardActionArea>
                        <CardActionArea className={'next-button'} onClick={p.moveNext}>
                            {/*{(p.buttonLabel) ? p.buttonLabel : "Next"}*/}
                            Next
                        </CardActionArea>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AnswerReveal;